export default __webpack_public_path__ + "static/media/whyChooseUs.a8cd7afe.png";